import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { enviroment } from "../enviroment";

class Connector {
    static instance: Connector;
    public events: (onMessageReceived: (username: string) => void) => void;
    private connection: HubConnection;

    constructor() {
        this.connection = new HubConnectionBuilder()
            .withUrl(enviroment.authHub)
            .withAutomaticReconnect()
            .build();
        this.connection.start().catch((err) => console.warn(err));

        this.events = (onMessageReceived) => {
            this.connection.on("InitiateSignOut", (username) => {
                onMessageReceived(username);
            });
        };
    }

    public static getInstance(): Connector {
        if (!Connector.instance) Connector.instance = new Connector();
        return Connector.instance;
    }
}

export default Connector;
